import { render, staticRenderFns } from "./CategoriaRepresentivaEdit.vue?vue&type=template&id=63af28f0&scoped=true&"
import script from "./CategoriaRepresentivaEdit.vue?vue&type=script&lang=js&"
export * from "./CategoriaRepresentivaEdit.vue?vue&type=script&lang=js&"
import style0 from "./CategoriaRepresentivaEdit.vue?vue&type=style&index=0&id=63af28f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63af28f0",
  null
  
)

export default component.exports